var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 27,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_21_981",
    transform: "matrix(0.0625 0 0 0.0694444 0 -0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_21_981",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAWQAAAFkBqp2phgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFTSURBVDiNlZI/S0JhFMZ/50XvvVHklEUEtho15SCBguBUUzQ4C0HfwaEp8Cv4HWpuadDr5NIgUY1BVKhQ0nCJvHRPQxrX8u/Zznmf53l/L+eFCaU1p6g1pzhJI2PN9aUV1H8EBD+SkLzXHqUz46/vnQAOYBP1j+ci0CoRjP0AbPRHLyx+bkoKfzYCYx2FzADreNbhSAJ17X1U0hhdQ1kFjYMkgdgf7TvoPUgHoU0gLUQboq7dBuLj3jilOoZACiDd+b3SJZCCAGjd2gK5REnM6H7GBAeS8ZsGQLK9O74iaZDrGcw3BCYtGb8JoS1Izmshwdl0cj2V3MfToB1eYyB7UwPUpMPtcIAwPQAd0vwG6C0WsBs68xAtIVoCvNA81df+IXiL7vDz90HkHExSsr2yZHtlMEmUi75ygdfo9n+wK2Lq2hWtOvmx8FUnr65d0QbLg9k3QflombXow/oAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ca85adcba169f01d596b55d1edb597f8.svg";
export { ForwardRef as ReactComponent };